import router from "./router";
import i18n from "./i18n";
import store from "./store";

export const webModuleRouter = router;
export const webModuleI18n = i18n;
export const webModuleStore = store;
